import { WithRouterGuard } from '@/common/components/RouterGuard/RouterGuard';
import { MARKET, PLAN } from '@/common/constants/markets';
import { ESWalletBenefitsActivity } from '@/web/containers/Dashboard/ESWalletDashboard/containers/Benefits/containers/ESWalletBenefitsActivity/ESWalletBenefitsActivity';

export default function BenefitsActivityPage() {
  return WithRouterGuard(<ESWalletBenefitsActivity />, {
    market: [MARKET.ES],
    plan: [PLAN.ES_WALLET, PLAN.ES_HYBRID],
  });
}
